import Button from "component/ui/Button";
import FullPageLoader from "component/ui/fullPageLoader";
import RatingStar from "component/ui/Star";
import Textarea from "component/ui/Textarea";
import React, { useState } from "react";

export default function AddRatingReview({
  handleRating,
  ratingData,
  setRatingData,
}) {
  const [hover, setHover] = useState(0);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl w-[380px] shadow-xl animate-in fade-in zoom-in-95">
        {/* Header */}
        {ratingData?.loader && <FullPageLoader />}
        <div className="px-6 pt-6 ">
          <h2 className="text-xl font-semibold text-gray-900">Rating</h2>
        </div>

        {/* Stars */}
        <div className="flex justify-center gap-3 my-6">
          {[1, 2, 3, 4, 5].map((star) => (
            <RatingStar
              key={star}
              filled={star <= (hover || ratingData?.rating)}
              onClick={() =>
                setRatingData((rating) => ({
                  ...rating,
                  rating: star,
                }))
              }
              onMouseEnter={() => setHover(star)}
              onMouseLeave={() => setHover(0)}
            />
          ))}
        </div>

        <div className="p-2">
          <Textarea
            value={ratingData?.description}
            onChange={(e) =>
              setRatingData((rating) => ({
                ...rating,
                description: e.target.value,
              }))
            }
            placeholder="Write your feedback here..."
          />
        </div>

        {/* Footer */}
        <div className="flex  gap-3 px-6 py-4 bg-gray-50 rounded-b-2xl">
          <Button
            fullWidth
            variant="secondary"
            onClick={() => setRatingData({})}
          >
            Cancel
          </Button>

          <Button
            fullWidth
            disabled={!ratingData?.rating}
            onClick={handleRating}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
}
